import classnames from 'classnames'
import PropTypes from 'prop-types'

import './navWrapper.scss'

const NavWrapper = props => (
  <div
    className={classnames(
      'nav-wrapper flex-child',
      props.displayBanner,
      {'ep-preview': props.isPreviewPage}
    )}>
    <div className='nav-inner-wrapper flex-container'>
      {props.children}
    </div>
  </div>
)

NavWrapper.propTypes = {
  displayBanner: PropTypes.string,
  isPreviewPage: PropTypes.bool
}

export default NavWrapper
